import type {
    CheckProjectNameData,
    CheckProjectNameReq,
    CreateProjectReq,
    HomeInfoData,
} from './interface';
import type {ProjectId} from '@/types';
import {request} from '@/services';

/**
 * 获取首页信息
 */
export const getHomeInfo = () => request.get<HomeInfoData>('proxy-aicomic/homepage/overview');

/**
 * 校验项目名称是否重名
 */
export const checkProjectName = (params: CheckProjectNameReq) =>
    request.post<CheckProjectNameData>('proxy-aicomic/project/name/check', params);

/**
 * 创建项目
 */
export const createProject = (params: CreateProjectReq) =>
    request.post<{projectId: ProjectId}>('proxy-aicomic/project/add', params);
